"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/sliderOne.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import { FC, ComponentProps } from "react";

type HomeEightSliderOneServicesItem = {
    /** Detected variants: "Laser-Assisted Surgeries" | "Sterile & Safe Surgical Environment" | "Advanced Retina & Diabetic Eye Care" | "Advanced Treatments" */
    text: string;
};
export type HomeEightSliderOneGeneratedProps = {
    services?: HomeEightSliderOneServicesItem[];
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeEightSliderOneGenerated: FC<HomeEightSliderOneGeneratedProps> = ({
    services = [],
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    sectionDiv0Swiper0SwiperProps,
}) => {
    return (
        <section className="slider-section-eight wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-one bg-dark d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <Swiper modules={[Autoplay, FreeMode]} slidesPerView="auto" spaceBetween={8} loop speed={12000} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }} freeMode allowTouchMove={false} className="slide-list d-flex" {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {services.map((text, index) => (
                        <SwiperSlide
                            key={index}
                            className="services-slide"
                            style={{ width: "auto" }}
                        >
                            <h3 className="mb-0">{text.text}</h3>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default HomeEightSliderOneGenerated;
